export default "__VITE_ASSET__D7Zzyi70__"